<app-page-loader></app-page-loader>
<router-outlet></router-outlet>
<app-cookie-consent></app-cookie-consent>
<app-spinner></app-spinner>
